(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceCategorizedModalController',InvoiceCategorizedModalController);

    InvoiceCategorizedModalController.$inject = ['$uibModalInstance','entity','invType','invStatus','InvoiceCustomService','MiscService','ToastrService','DateUtils'];

    function InvoiceCategorizedModalController($uibModalInstance, entity, invType, invStatus, InvoiceCustomService, MiscService, ToastrService, DateUtils) {
        var vm = this;

        vm.categoryInvoice = entity;
        vm.invType = invType;
        vm.invStatus = invStatus;

        vm.setPrecision = setPrecision;
        vm.returnCommission = returnCommission;
        vm.computeTotal = computeTotal;
        vm.computeValue = computeValue;

        vm.invoices = [];
        vm.statusText = "Fetching Invoices...";

        vm.startDate = MiscService.dateFix(vm.categoryInvoice.startDate);
        vm.endDate = MiscService.dateFix(vm.categoryInvoice.endDate);

        fetchInvoiceItems(vm.startDate, vm.endDate, vm.invType, vm.invStatus, vm.categoryInvoice.category);

        function fetchInvoiceItems(startDate, endDate, invType, invStatus, category) {
            vm.invoices = [];
            InvoiceCustomService.returnCategoryInvoiceItems(DateUtils.convertLocalDateToServer(startDate), DateUtils.convertLocalDateToServer(endDate),
                                                            invType, invStatus, category).then(function(result) {
                 vm.invoices = result.data;
                 generateStatusText();
                 if(vm.invoices.length === 0) {
                     vm.statusText = "No Invoices fetched withtin the date range given";
                     ToastrService.info(vm.statusText, "Info");
                 }
            }, function(error) {
                vm.statusText = "Couldn't fetch Invoices...";
                if(error.status !== "404") {
                    ToastrService.error(vm.statusText, "Error");
                }
                vm.invoices = [];
            });
        }

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function generateStatusText() {
            if(vm.startDate.getTime() === vm.endDate.getTime()) {
                vm.statusText = "Showing " + vm.invoices.length + " Invoices for " + vm.startDate.toLocaleDateString('en-US');
            } else {
                vm.statusText = "Showing " + vm.invoices.length + " Invoices from " + vm.startDate.toLocaleDateString('en-US') + " to " + vm.endDate.toLocaleDateString('en-US');
            }
        }

        function setPrecision(value) {
            return parseFloat(value.toString()).toFixed(2);
        }

        function returnCommission(invoice) {
            return invoice.invType === "JAPAN" ? setPrecision("0") : setPrecision(invoice.commissionValue);
        }

        function computeTotal(invoice) {
            return invoice.invType === "JAPAN" ? setPrecision(invoice.editedTotalValue) : computeValue(invoice.editedTotalValue, invoice.commissionValue);
        }

        function computeValue(value, commission) {
            var returnMe = parseFloat(value) + parseFloat(commission);
            return parseFloat(returnMe.toString()).toFixed(2);
        }

    }
})();
